import { createTheme } from '@mui/material/styles';
import shippoTheme from '../styles/shippoTheme.js';

const tabsThemeInput = {
    components: {
        MuiTabs: {
            styleOverrides: {
                root: {},
            },
        },
    },
};
var tabsTheme = createTheme(shippoTheme, tabsThemeInput);

export { tabsTheme as default, tabsThemeInput };
//# sourceMappingURL=Tabs.theme.js.map
